module.exports = __webpack_public_path__ + "static/images/components/Pagination/PaginationArrowButton/images/pagination-arrow.addab66b.png";


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationArrowButton/images/pagination-arrow.png
// module id = 2653
// module chunks = 11